import { render } from "./sales-report.vue?vue&type=template&id=bbb4b222&scoped=true"
import script from "./sales-report.vue?vue&type=script&lang=js"
export * from "./sales-report.vue?vue&type=script&lang=js"

import "./sales-report.vue?vue&type=style&index=0&id=bbb4b222&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\bmac\\ims-web-api\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbb4b222"]])

export default __exports__